import React, { Component } from "react"
import { Input, Table, Row, Select, message } from "antd"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import MaterialModal from "app/components/normal/MaterialModal"
import { observer, inject } from "mobx-react"
import { PREPARE_RUN, RUNNING } from 'app/utils/const'
import closeIcon from "app/styles/images/sp/close.svg"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import SwitchS from "app/components/normal/FormComponents"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

const Option = Select.Option
const ObserverSwitch = observer(({ record, toggleSwitch }) => {
  return (
    <SwitchS
      onChange={() => toggleSwitch(record)}
      checked={!record.disable}
    />
  )
})

@inject("auth") @observer
class Index extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      dataSingle: {}
    }
    this.columns = []
  }

  componentDidMount() {
    const { store: { list, getOrgList } } = this.props
    getOrgList()
    this.props.auth.getChannelApps()
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  showEditModal = (record) => {
    this.setState({
      showEditModal: true,
    })
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  updateField = (e, field) => {
    this.setState({
      dataSingle: { ...this.state.dataSingle, [field]: e.target.value }
    })
  }

  handleEdit = (userId) => {
    const { getAccountDetail } = this.props.store
    getAccountDetail(userId).then(
      res => {
        this.setState({
          showEditModal: true,
        })
      }
    )
  }

  render() {
    const { apps, channelApps } = this.props.auth
    const { detailData, setDetailData, updateAccount, orgList } = this.props.store
    const appArray = detailData.get('apps')
    let hasApps = false
    if (appArray) {
      hasApps = true
    }
    const showChannel = appArray && appArray.indexOf('pgs') > -1
    const {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        }
      },
    } = this.props
    const renderContent = (text, record, index) => {
      const obj = {
        children: text,
        props: {},
      }
      if (record.state === PREPARE_RUN || record.state === RUNNING) {
        obj.props.colSpan = 0
      }
      return obj
    }

    const columns = [
      {
        width: "15%",
        title: "用户名",
        dataIndex: "username",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "15%",
        title: "机构名称",
        dataIndex: "orgName",
        render: (text) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "15%",
        title: (<div className="ta-l">姓名</div>),
        className: "ta-l",
        dataIndex: "truename",
        render: (text, record, index) => {
          return (
            <div>{text}</div>
          )
        }
      }, {
        width: "20%",
        title: (<div className="ta-l">邮箱</div>),
        className: "ta-l",
        dataIndex: "email",
        render: renderContent
      }, {
        width: "10%",
        title: (<div className="ta-l">创建时间</div>),
        className: "ta-l",
        dataIndex: "createTime",
        render: renderContent
      }, {
        width: "15%",
        title: (<div className="ta-l">停启用</div>),
        className: "ta-l",
        dataIndex: "isCheck",
        render: (text, record) => {
          const { toggleSwitch } = this.props.store
          return (
            <ObserverSwitch
              toggleSwitch={toggleSwitch}
              record={record}
            />
          )
        }
      }, {
        width: 104,
        title: "操作",
        dataIndex: "operator",
        className: "ta-c",
        render: (text, record) => {
          return (
            <Row className="table-oprator" type="flex" justify="space-between" align="middle">
              <img
                title="修改"
                src={editAbleIcon}
                alt=""
                style={{ cursor: 'pointer' }}
                onClick={() => this.handleEdit(record.id)}
              />
            </Row>
          )
        }
      }
    ]

    return (
      <div className="wrapper-box">
        <Table
          columns={columns}
          className="statistics-table"
          rowKey={record => record.reportId}
          dataSource={tableData.slice()}
          pagination={{
            pageSize: queryMap.limit,
            onChange: this.onPaginChange,
            defaultCurrent: 1,
            current: currentPageIndex,
            total: totalCount,
          }}
        />
        <MaterialModal
          title="编辑子账户"
          width={450}
          className="preview-account-create-modal"
          visible={this.state.showEditModal}
          buttonText="确认添加"
          action={
            () => {
              return updateAccount()
                .then(
                  res => {
                    message.success('修改成功')
                    this.closeModal('showEditModal')
                  }
                )
            }

          }
        >
          <img
            className="pgx-modal-close"
            src={closeIcon}
            alt="关闭对话框"
            onClick={() => this.closeModal("showEditModal")}
          />
          <MaterialForm>
            <MaterialFormItem
              labelText="用户名"
              labelWidth={60}
            >
              <Input
                className="createAccount-input"
                placeholder="请输入用户名"
                value={detailData.get('username')}
                onChange={(e) => setDetailData({ username: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="姓名"
              justify="center"
            >
              <Input
                name="name"
                className="createAccount-input"
                placeholder="请输入姓名"
                value={detailData.get('truename')}
                onChange={(e) => setDetailData({ truename: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="密码"
              justify="center"
            >
              <Input
                name="password"
                className="createAccount-input"
                type="password"
                value='12345678'
                disabled
                placeholder="请输入密码"
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="确认密码"
              justify="center"
            >
              <Input
                name="rePassword"
                type="password"
                value="12345678"
                disabled
                className="createAccount-input"
                placeholder="请再次输入密码"
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={70}
              labelText="手机号码"
              justify="center"
            >
              <Input
                name="phone"
                className="createAccount-input"
                value={detailData.get('phone')}
                placeholder="请输入手机号码"
                onChange={(e) => setDetailData({ phone: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="邮箱"
              justify="center"
            >
              <Input
                name="email"
                value={detailData.get('email')}
                className="createAccount-input"
                placeholder="请输入邮箱地址"
                onChange={(e) => setDetailData({ email: e.target.value })}
              />
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={70}
              labelText="所属机构"
              justify="center"
            >
              <Select
                showSearch
                value={detailData.get("orgId")}
                placeholder="请选择所属机构"
                className="createAccount-input"
                onChange={(e) => setDetailData({ orgId: e })}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {orgList.slice().map(org => <Option key={org.id}>{org.name}</Option>)}
              </Select>
            </MaterialFormItem>
            <MaterialFormItem
              labelWidth={60}
              labelText="可操作应用"
              justify="center"
            >
              <Select
                placeholder="请选择可操作应用"
                className="createAccount-input"
                multiple
                value={hasApps ? appArray.slice() : []}
                onChange={(e) => setDetailData({ apps: e })}
              >
                {apps.slice().map(app => <Option key={app}>{app}</Option>)}
              </Select>
            </MaterialFormItem>
            {showChannel && (
              <MaterialFormItem
                labelWidth={70}
                labelText="PGS上传通道"
                justify="center"
              >
                <Select
                  value={detailData.get("appIds") ? detailData.get("appIds").slice() : []}
                  placeholder="请选择pgs上传通道"
                  className="createAccount-input"
                  multiple
                  onChange={(e) => setDetailData({ appIds: e })}
                >
                  {channelApps.slice().map(app => <Option key={app.id}>{app.name}</Option>)}
                </Select>
              </MaterialFormItem>
            )}
          </MaterialForm>
        </MaterialModal>
      </div>
    )
  }
}

export default Index



// WEBPACK FOOTER //
// ./src/app/pages/preview/bypass-account/containers/DataTable.js